export default __webpack_public_path__ + "b4400872b05f39b5d1c4bdded78e19db.svg";